import { Form } from 'factorial-form'
import { xor } from 'lodash'

type IdsTypes = number[] | (number | null | undefined)

interface Props {
  form: Form
  selectedEmployees: number[]
  setSelectedEmployees: (value: number[]) => void
}

const useOnSelectEmployees = ({ form, selectedEmployees, setSelectedEmployees }: Props) => {
  const onSelectEmployee = (ids: IdsTypes) => {
    const field = form.get('employee_id')
    let selectedEmployeeIds: number[] = []

    if (ids instanceof Array) {
      selectedEmployeeIds = ids
    } else {
      selectedEmployeeIds = ids ? xor(selectedEmployees, [ids]) : []
    }

    setSelectedEmployees(selectedEmployeeIds)

    if (selectedEmployeeIds.length > 0) {
      field.set(selectedEmployeeIds[0])
      form.get('employee_id').setErrors([])
    } else {
      field.set(null)
    }
  }

  return { onSelectEmployee }
}

export { useOnSelectEmployees }
